export default __webpack_public_path__ + "static/media/invite_guests.bf2d04ab.svg";